/**
 * @param {String} state
 * @param {String} country
 * @return {Boolean}
 */
export function isNorthAmericanCountry(country = '') {
    return ['us', 'ca', 'mx'].includes(country.toLowerCase());
}

/**
 * @param {String} country=''
 * @return {Boolean}
 */
export function regionFromStateAndCountry(state, country) {
    if (!country) {
        return undefined;
    }

    return (['us', 'ca']).indexOf(country.toLowerCase()) !== -1
        ? (state || country) // sometimes state doesn't exist I guess?
        : country;
}
